import { twMerge } from 'tailwind-merge';
import { Heading, FontWeight, useFontClass } from '../../tokens';
import type { SegmentedSwitchButtonProps } from './SegmentedSwitch.types';

export const SegmentedSwitchButton = ({
  option,
  isSelected,
  parentDisabled,
  onClick,
  ...rest
}: SegmentedSwitchButtonProps) => {
  const isDisabled = parentDisabled || option.disabled;
  const { fontClass } = useFontClass(isSelected ? FontWeight.MEDIUM : FontWeight.REGULAR);

  const className = twMerge(
    'flex-1 py-[12px] px-[16px] rounded-[6px] transition-all duration-200 h-full',
    'flex items-center justify-center gap-[6px] w-full',
    isSelected && 'bg-surface-primary-bw-00 text-text-brand-primary',
    isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
  );

  return (
    <button
      type='button'
      role='radio'
      aria-checked={isSelected}
      disabled={isDisabled}
      className={className}
      onClick={isDisabled ? undefined : onClick}
      {...rest}>
      {option.icon && (
        <span className='flex-shrink-0 text-inherit w-[16px] h-[16px]'>{option.icon}</span>
      )}
      <Heading.H9 className={`${fontClass} text-inherit`}>{option.label}</Heading.H9>
    </button>
  );
};
